'use client';

import { Button, Card, CardContent, Input, Logo } from '@lectura/ui';
import { Lock, Mail } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useAuth } from '@/lib/auth';

export default function LoginPage() {
  const router = useRouter();
  const login = useAuth((s) => s.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      // useAuth.login() tárolja az access tokent (Zustand-Persist), a refresh
      // a httpOnly cookie-ba megy, és lekéri a `/users/me`-t. Ha a usernek
      // aktív TOTP MFA-secretje van, a backend `mfa_required` választ ad —
      // ekkor TOTP-input page-re navigálunk.
      const result = await login(email, password);
      if (result.status === 'mfa_required') {
        // `td=1` → a verify-oldal megmutatja az "eszköz megjegyzése" checkboxot
        // (csak ha a backend engedélyezte: feature on ÉS nem admin).
        const tdParam = result.trustedDeviceAllowed ? '?td=1&' : '?';
        router.push(`/mfa/verify${tdParam}challenge=${encodeURIComponent(result.mfaChallengeToken)}`);
        return;
      }
      router.push('/library');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'A kiszolgáló nem érhető el.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="bg-brand-gradient flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md bg-white">
        <CardContent className="p-8">
          <div className="mb-6 flex justify-center">
            <Logo />
          </div>
          <h1 className="mb-1 text-center font-display text-2xl font-bold">Üdv újra!</h1>
          <p className="mb-6 text-center text-sm text-[var(--color-foreground-muted)]">
            Lépj be, hogy folytasd az olvasást.
          </p>
          <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
            <Input
              type="email"
              autoComplete="email"
              required
              placeholder="email@példa.hu"
              leftSlot={<Mail className="size-4" />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              type="password"
              autoComplete="current-password"
              required
              minLength={8}
              placeholder="Jelszó"
              leftSlot={<Lock className="size-4" />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error ? <p className="text-sm text-red-600">{error}</p> : null}
            <Button type="submit" loading={submitting} size="lg" className="mt-2">
              Belépés
            </Button>
          </form>
          <div className="mt-6 flex items-center justify-between text-sm">
            <Link href="/forgot" className="text-brand-600 hover:underline">
              Elfelejtett jelszó
            </Link>
            <Link href="/signup" className="text-brand-600 hover:underline">
              Regisztráció
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
